const credentialKeys = new Set(["secret_key", "webhook_password"]);

export function isSchoolStoreTelemetryUrl(value: string): boolean {
  const path = value.split(/[?#]/, 1)[0];
  return /\/api\/(?:organizations\/current\/store(?:\/|$)|commerce\/maintenance(?:\/|$)|admin\/commerce(?:\/|$)|accounts\/store-maintenance\/(?:login|refresh)(?:\/|$))/.test(
    path,
  );
}

export function isSchoolStoreRoutePath(path: string): boolean {
  return /^\/(?:school-dashboard\/store|store-maintenance)(?:\/|$)/.test(path);
}

/** Vue props and Axios errors can include credentials and private buyer snapshots. */
export function containsSchoolStoreSensitiveTelemetry(
  value: unknown,
  seen = new WeakSet<object>(),
): boolean {
  if (typeof value === "string") {
    if (
      isSchoolStoreTelemetryUrl(value) ||
      /"(?:secret_key|webhook_password)"\s*:/.test(value)
    )
      return true;
    if (
      /"buyer"\s*:/.test(value) &&
      /"items"\s*:/.test(value) &&
      /"total_cents"\s*:/.test(value)
    )
      return true;
    return false;
  }
  if (!value || typeof value !== "object" || seen.has(value)) return false;
  seen.add(value);
  const snapshot = value as Record<string, unknown>;
  if (
    snapshot.buyer &&
    typeof snapshot.buyer === "object" &&
    Array.isArray(snapshot.items) &&
    typeof snapshot.total_cents === "number"
  )
    return true;
  return Object.entries(value).some(
    ([key, item]) =>
      credentialKeys.has(key.toLowerCase()) ||
      containsSchoolStoreSensitiveTelemetry(item, seen),
  );
}
